import { BareButton } from '@calendly/ui/components/bare-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { usePresetFilterSheetLayout } from '../preset_filter_sheet_layout_context';
import { presetFilterCheckboxLabelCss } from '../preset_filter_sheet_styles';
import { LeftColumn } from './left_column';
import { RightColumn } from './right_column';
const labelContainerCss = "lpkp0zx";
export const LabelContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelContainerCss, props.className)} />;
});
const dateDropdownButtonIsPhoneCss = "d14s2x2";
const dateDropdownButtonCss = "d1d9cz04";
export const DateDropdownButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(dateDropdownButtonCss, {
    [dateDropdownButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
const checkboxLeftColumnWrapperIsPhoneCss = "c1l2ttjl";
const checkboxLeftColumnWrapperFieldColumnCss = "c1dr9dpa";
const checkboxLeftColumnWrapperCss = "c1v5s45x";
export const CheckboxLeftColumnWrapper = forwardRef((props, ref) => {
  const {
    fieldColumn
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <LeftColumn ref={ref} {...props} className={classNames(checkboxLeftColumnWrapperCss, {
    [checkboxLeftColumnWrapperIsPhoneCss]: isPhone,
    [checkboxLeftColumnWrapperFieldColumnCss]: fieldColumn
  }, props.className)} />;
});
const checkboxRightColumnWrapperIsPhoneCss = "chagqg6";
const checkboxRightColumnWrapperFieldColumnCss = "c1a1fvnm";
const checkboxRightColumnWrapperCss = "c1ofzv53";
export const CheckboxRightColumnWrapper = forwardRef((props, ref) => {
  const {
    fieldColumn
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <RightColumn ref={ref} {...props} className={classNames(checkboxRightColumnWrapperCss, {
    [checkboxRightColumnWrapperIsPhoneCss]: isPhone,
    [checkboxRightColumnWrapperFieldColumnCss]: fieldColumn
  }, props.className)} />;
});
const rightColumnWrapperIsPhoneCss = "r1gacimj";
const rightColumnWrapperCss = "rsh6vag";
export const RightColumnWrapper = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <RightColumn ref={ref} {...props} className={classNames(rightColumnWrapperCss, {
    [rightColumnWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledLabelCss = "sdhw0j6";
export const StyledLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  const presetSheet = usePresetFilterSheetLayout();
  return <Component ref={ref} {...restProps} className={classNames(styledLabelCss, {
    [presetFilterCheckboxLabelCss]: presetSheet
  }, props.className)} />;
});
const checkboxContainerIsPhoneCss = "c1g4y0p";
const checkboxContainerFieldColumnCss = "cc4t4s1";
const checkboxContainerCss = "c1q86kha";
export const CheckboxContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    fieldColumn,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(checkboxContainerCss, {
    [checkboxContainerIsPhoneCss]: isPhone,
    [checkboxContainerFieldColumnCss]: fieldColumn
  }, props.className)} />;
});
const optionWrapperCss = "o1hqcj6u";
export const OptionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");